import React from "react"
import { Link, graphql } from "gatsby"
import _ from "lodash"
import styles from "../styles/global.module.scss"

// Components
import Layout from "../components/layout/layout"
import ServiceItems from "../components/services/service-items"

import { useGetTokens } from "../hooks/useGetTokens"
import convertTokens from "../helpers/convertTokens"
import setSeoData from "../helpers/setSeoData"

export default ({ data, location }) => {
  const service = data.service.frontmatter
  const sub_services = data.sub_services.edges
  // Get metadata
  const metadata = useGetTokens()

  let seo_data = setSeoData(service)

  return (
    <Layout location={location} seo_data={seo_data}>
      <div className={styles.container}>
        <section className={styles.serviceContent}>
          <h1>{service.name}</h1>
          <div
            dangerouslySetInnerHTML={{
              __html: convertTokens(data.service.html, metadata),
            }}
          />
          <div className={`${styles.buttonContain}`}>
            <Link
              className={`${styles.btn} ${styles.btnSmall} ${styles.btnLeft}`}
              to={`/request-a-quote/`}
              state={{
                service: service.name,
              }}
            >
              Request Quote
            </Link>
          </div>
          <div dangerouslySetInnerHTML={{ __html: service.html }} />
        </section>
        {!_.isEmpty(sub_services) ? (
          <div className={styles.serviceListContain}>
            <h3>{service.name} Services:</h3>
            <ServiceItems services={sub_services} />
          </div>
        ) : null}
      </div>
    </Layout>
  )
}
export const query = graphql`
  query($slug: String!, $cat_id: String!) {
    service: markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      frontmatter {
        cat_id
        name
        meta {
          title
          description
          page_visible
        }
        category
        is_active
      }
    }
    sub_services: allMarkdownRemark(
      filter: {
        frontmatter: {
          category: { eq: $cat_id }
          is_active: { eq: true }
          meta: { page_visible: { eq: true } }
        }
      }
    ) {
      edges {
        node {
          id
          html
          frontmatter {
            template
            category
            description
            is_active
            name
          }
          fields {
            slug
          }
        }
      }
    }
  }
`
